import { Link } from "@circleco/compass/components/Link";
import { Tooltip } from "@circleco/compass/components/Tooltip";
import { Link as RouterLink } from "@tanstack/react-router";

import { useCommentsDeepLink } from "@/react/components/CommentsCompass/Provider/useCommentsDeepLink";
import { cssAnchorProps } from "@/react/helpers/cssAnchorHelpers";
import {
  dateStringToTimeAgo,
  dateToTimeAgoFormats,
} from "@/react/helpers/dateTimeHelpers/timeAgo";
import { getDetailedTimestamp } from "@/react/helpers/postHelpers";
import type { Comment } from "@/react/types/Comment";

interface TimestampProps {
  comment: Comment;
}

export const Timestamp = ({ comment }: TimestampProps) => {
  const { getCommentLinkProps } = useCommentsDeepLink();
  const linkProps = getCommentLinkProps(comment.id);

  return (
    <Tooltip content={getDetailedTimestamp(comment.created_at)}>
      <Link
        renderLink={<RouterLink {...linkProps} />}
        variant="custom"
        typography="body-sm"
        color="secondary"
        hoverColor="primary"
        className="shrink-0"
        {...cssAnchorProps({ anchor: "comment-author-timestamp" })}
      >
        {dateStringToTimeAgo(comment.created_at, {
          format: dateToTimeAgoFormats.short,
        })}
      </Link>
    </Tooltip>
  );
};
